import { Add, Delete, Edit, Filter1, Filter2, Filter3, Filter4, Filter5, Person } from "@mui/icons-material";
import { Box, Button, Checkbox, Chip, Divider, IconButton, MenuItem, Modal, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, tooltipClasses } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../Layout/Loader/Loaders";
import axios from "axios";
import { Url } from "../../constants";
import Swal from "sweetalert2";

const TableUsuarios = () => {

    const token = localStorage.getItem("token")
    const user_datos = JSON.parse(localStorage.getItem("user"))
    const [isCharging, setisCharging] = useState(false)
    const Navigate = useNavigate()
    const [permisos, setpermisos] = useState([])

    const [catalogo_modulos, setcatalogo_modulos] = useState([]);
    const [catalogo_roles, setcatalogo_roles] = useState([])
    const [allUsers, setallUsers] = useState([])
    const [selectModule, setselectModule] = useState("")

    const [typeModal, settypeModal] = useState("Crear")

    const [openModalRegistro, setopenModalRegistro] = useState(false)
        const [new_User, setnewUser] = useState({
            "nombre":null,
            "apellido_p":null,
            "password":"",
            "email":"",
            "usuario_rol": 0
          })
        const [modul_files_selected, setselectmodulfiles] = useState([])
        const [files_selected, setfiles_selected] = useState([])

    const getModulos = async () => {
        setisCharging(true)
        await axios.get(Url + "GetCatalogos", {
            headers: {
                Authorization: token
            }
        })
        .then(res => {
            setisCharging(false)
            setcatalogo_modulos(res.data.Catalogos)
        })
        .catch(err => {
            setisCharging(false)
            console.log(err)
        })
    }
    const getRoles = async () => {
        setisCharging(true)
        await axios.get(Url + "GetRoles", {
            headers: {
                Authorization: token
            }
        })
        .then(res => {
            setisCharging(false)
            setcatalogo_roles(res.data.Roles)
        })
        .catch(err => {
            setisCharging(false)
            console.log(err)
        })
    }

    const getallUsers = async () => {
        setisCharging(true)
        await axios.get(Url + "GetUsuarios", {
            headers: {
                Authorization: token
            }
        })
        .then(res => {
            setisCharging(false)
            setallUsers(res.data.Usuarios)
        })
        .catch(err => {
            setisCharging(false)
            console.log(err)
        })
    }

    const getPantallasbyRol = async () => {
        await axios.get(Url + "GetRol?id=" + user_datos.roluser_id, {
            headers: {
                Authorization: token
            }
        })
        .then(res => {
            if (res.data.length > 0) {
                const resultado = res.data.find(obj => obj.pantalla.pantalla === "Usuarios");
                setpermisos(resultado.permisos)
            }
        })
        .catch(err => {
            console.log(err)
        })
    }

    useEffect(() => {
        if (token && !["null", "undefined"].includes(token)) {
            if (![3,5].includes(user_datos.roluser_id)) {
                getModulos()
                getRoles()
                getallUsers()
                getPantallasbyRol()
            } else {
                Navigate("/archivos")
            }
        } else {
            localStorage.clear()
            Navigate("/login")
        }
    },[])

    const styleicon = {
        color: "black",
    }

    const changeLevelforIcon = (nivel) => {
        switch (nivel) {
            case 1:
                return <Filter1 sx={styleicon}/>;

            case 2:
                return <Filter2 sx={styleicon}/>;

            case 3:
                return <Filter3 sx={styleicon}/>;

            case 4:
                return <Filter4 sx={styleicon}/>;
        
            case 5:
                return <Filter5 sx={styleicon}/>;

            default:
                break;
        }
    }

    //Create User
    const AddPerson = () => {
        settypeModal("Crear")
        setopenModalRegistro(true)
        setselectModule("")
    }
        const handleChangeDatosNewUser = (event) => {
            const value = event.target.value;
            const name = event.target.name;

            const copyNewUser = {...new_User}
            copyNewUser[name] = value
            setnewUser(copyNewUser)
        }

        const handleSelectModul = async (nombre_modul, id_modulo_select) => {
            setisCharging(true)
            setselectModule(nombre_modul)

            await axios.get(Url + "GetArchivos?modulo="+id_modulo_select, {
                headers:{
                    Authorization: token
                }
            })
            .then(res => {
                setselectmodulfiles(res.data.Archivos)
                setisCharging(false)
            })
            .catch(err => {
                setisCharging(false)
                console.log(err)
            })
        }
        //Método Seleccionar o deseleccionar todos los archivos
        const un_selectall = (event) => {
            const checked_prop = event.target.checked
            const copyfiles_selected = [...files_selected]
            
            if (checked_prop) {
                modul_files_selected.forEach(element => {
                    copyfiles_selected.push(element.id)
                }); 

                setfiles_selected(copyfiles_selected)
            } else {
                const setfiles_modul = new Set(modul_files_selected.map(obj => obj.id))
                const newarray_filter = copyfiles_selected.filter(file => !setfiles_modul.has(file))

                setfiles_selected(newarray_filter)
            }
        }
        //Método seleccionar/deseleccionar un archivo
        const add_selectfile = (event, id_file) => {
            const copy_addfiles = [...files_selected]
            
            if (event.target.checked) {
                copy_addfiles.push(id_file)
            } else {
                const var_delete = copy_addfiles.indexOf(id_file)
                copy_addfiles.splice(var_delete, 1)
            }
            setfiles_selected(copy_addfiles)
        }
        //Save New User
        const saveNewUser = async () => {
            setisCharging(true)
            try {
                const resp = await axios.post(Url + "CrearUsuario", new_User, {
                    headers:{
                        Authorization: token
                    }
                })

                if (new_User.usuario_rol === 5) {
                    for (const file_id of files_selected) {
                        console.log(Url + "UsuarioArchivo?usuario=" + resp.data.Usuario.id + "&archivo=" + file_id)
                        await axios.post(Url + "UsuarioArchivo?usuario=" + resp.data.Usuario.id + "&archivo=" + file_id, "", {
                            headers: {
                                Authorization: token
                            }
                        })
                    }
                }

                closeModal();
                getallUsers()
                Swal.fire("Usuario creado con éxito", "", "success")
                setisCharging(false)

            } catch (error) {
                console.log(error)
                Swal.fire({
                    title:"Ocurrió un error al momento de agregar al usuario",
                    backdrop: false,
                    icon:"error",
                    didOpen: () => {
                        document.querySelector(".swal2-container").style.zIndex = "1400";
                      }
                })
                setisCharging(false)
            }
        }

    //Modal
    const closeModal = () => {
        setopenModalRegistro(false)
        setnewUser({
            "nombre":null,
            "apellido_p":null,
            "password":"",
            "email":"",
            "usuario_rol": 0
          })
        setfiles_selected([])
        settypeModal("Crear")
    }

    //Update User
    const getInfoUserbyId = async (id_user) => {
        settypeModal("Actualizar")
        
        setisCharging(true)
        setopenModalRegistro(true)
        setselectModule("")

        await axios.get(Url + "GetUsuario?id="+id_user, {
            headers:{
                Authorization: token
            }
        })
        .then(res => {
            setisCharging(false)
            const objUsuario = res.data.usuario
            objUsuario.password = ""
            setnewUser(objUsuario)
        })
        .catch(err => {
            setisCharging(false)
            console.log(err)
        })
    }

    const saveChangesUpdate = async () => {
        setisCharging(true)
        if (new_User.password === "" || !new_User.password) {
            delete  new_User.password    
        }

        await axios.put(Url + "UpdateUsuario", new_User, {
            headers: {
                Authorization: token
            }
        })
        .then(res => {
            closeModal()
            setisCharging(false)
            getallUsers();
            Swal.fire("Usuario actualizado","","success")
        })
        .catch(err => {
            closeModal()
            setisCharging(false)
            Swal.fire("Error al actualizar el usuario","","error")
            console.log(err)
        })
    }

    //Delete User
    const deleteUser = async (id_user_delete) => {
        setisCharging(true)

        await axios.delete(Url + "DeleteUsuario/"+ id_user_delete, {
            headers: {
                Authorization: token
            }
        })
        .then(res => {
            setisCharging(false)
            getallUsers();
            Swal.fire("Usuario eliminado","","success")
        })
        .catch(err => {
            setisCharging(false)
            console.log(err)
            Swal.fire("Error al eliminar al usuario","","error")
        })
    }

    const styleHead = {
        textAlign: "center",
        color: "white",
        backgroundColor: "#808b96"
        //fontWeight: "bold",
    };

    const styleRowBody = {
        textAlign: "center",
    };

    const styleToolTip = {
        popper: {
          sx: {
            [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
              {
                marginTop: '6px',
              },
          },
        },
      };

    return (
        <div>
            <TableContainer>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell sx={styleHead}>ID</TableCell>
                        <TableCell sx={styleHead}>Usuario</TableCell>
                        <TableCell sx={styleHead}>Correo</TableCell>
                        <TableCell sx={styleHead}>Nivel de Rol</TableCell>
                        <TableCell sx={styleHead}>Acciones</TableCell>
                        <TableCell sx={styleHead}>
                            {permisos.includes("crear") &&
                                <IconButton size="small" sx={{color:"white", border:"1px solid", borderRadius:3}}
                                onClick={AddPerson}>
                                    <Add fontSize="small" sx={{color:"white"}}/>
                                    <Person fontSize="small" sx={{color:"white"}}/>
                                </IconButton>
                            }
                        </TableCell>

                        <Modal sx={{display:"flex", justifyContent:"center", alignItems:"center", height: "100%"}} 
                        open={openModalRegistro} onClose={closeModal}>
                            <Box sx={{display:"flex", flexDirection:"column",
                               alignItems:"center", gap:5, width:"80%", height:"80vh", backgroundColor:"white",
                               overflowY:"auto"
                            }}>
                                <Box sx={{display:"flex", justifyContent:"space-between", alignItems:"center",
                                    width:"100%", p:1
                                }}>
                                    <h2>{typeModal === "Crear" ? "Registro" : "Actualización"} de Usuario</h2>
                                    <Button color="error" variant="outlined" onClick={closeModal}>X</Button>
                                </Box>
                                <Divider sx={{width:"100%", mt:"-2%"}}/>
                                <Box sx={{display:"flex", justifyContent:"space-around", alignItems:"center",
                                    width:"95%", flexDirection: { xs: 'column', sm: 'row' }
                                }}>
                                    <div style={{display:"flex", alignItems:"center", gap:5}}>
                                        <label>Nombre: </label>
                                        <TextField variant="standard" value={new_User.nombre || ""} 
                                        onChange={handleChangeDatosNewUser} name="nombre" autoComplete="off" />
                                    </div>
                                    <div style={{display:"flex", alignItems:"center", gap:5}}>
                                        <label>Apellido: </label>
                                        <TextField variant="standard" value={new_User.apellido_p || ""} 
                                        onChange={handleChangeDatosNewUser} name="apellido_p" autoComplete="off"/>
                                    </div>
                                </Box>

                                <Box sx={{display:"flex", alignItems:"center", justifyContent:"space-around",
                                    width:"95%"
                                }}>
                                    <div style={{display:"flex", alignItems:"center", gap:8}}>
                                        <label>Rol:</label>
                                        <Select
                                            variant="standard"
                                            onClose={() => {
                                                setTimeout(() => {
                                                document.activeElement.blur();
                                                }, 0);
                                            }}
                                            value={new_User.usuario_rol}
                                            sx={{fontSize:15, width:200}}
                                            name="usuario_rol"
                                            onChange={handleChangeDatosNewUser}
                                        >
                                            <MenuItem value={0} disabled>--Seleccione--</MenuItem>
                                            {catalogo_roles
                                            .filter(rol => user_datos.roluser_id === 1 || rol.id !== 1)
                                            .map((rol, index_rol) => (
                                                <MenuItem value={rol.id} key={index_rol}>{rol.rol}</MenuItem>
                                            ))}
                                        </Select>
                                    </div>

                                    <div style={{display:"flex", alignItems:"center", gap:5}}>
                                        <label>Correo:</label>
                                        <TextField variant="standard" autoComplete="off" value={new_User.email || ""} 
                                        onChange={handleChangeDatosNewUser} name="email" sx={{width:250}}/>
                                    </div>

                                    <div style={{display:"flex", alignItems:"center", gap:5}}>
                                        <label>Contraseña:</label>
                                        <TextField variant="standard" autoComplete="off" 
                                        value={new_User.password || ""}
                                        placeholder={typeModal === "Actualizar" ? "Ingresa contraseña nueva":""}
                                        onChange={handleChangeDatosNewUser} name="password"/>
                                    </div>
                                    
                                </Box>

                                {new_User.usuario_rol === 5 &&
                                <>
                                <Box sx={{display:"flex", gap:3, flexShrink:0, width:"90%", overflowX:"auto" 
                                    }}>
                                    {catalogo_modulos.map((modulo, indexModulo) => (
                                        <Box key={indexModulo} sx={{display:"flex", alignItems:"center"}}>                       
                                            <Chip label={modulo.catalogo_modulo} 
                                            sx={{mr:-1, 
                                                ":hover":{backgroundColor:"#3498db", cursor:"pointer",
                                                    color:"white",
                                                },
                                                backgroundColor: selectModule === modulo.catalogo_modulo && "#3498db",
                                                color: selectModule === modulo.catalogo_modulo && "white"
                                            }}
                                            onClick={() => handleSelectModul(modulo.catalogo_modulo, modulo.id)}
                                            />
                                            <Checkbox onChange={un_selectall}/>
                                        </Box>
                                    ))}
                                </Box>
                                {selectModule !== "" &&
                                    <Box sx={{width:"90%", minHeight:"30vh", borderRadius:10,
                                        border:"1px solid", p:2, display:"flex", gap:2, flexWrap:"wrap",
                                        overflowY:"auto", 
                                    }}>
                                        {modul_files_selected.length > 0 ?
                                            <>
                                            {modul_files_selected.map((archivo, indexArchivo) => (
                                                <Box key={indexArchivo}>
                                                    <Checkbox sx={{mt:-1, mr:-1}} 
                                                        checked={files_selected.includes(archivo.id)}
                                                        onChange={(e) => 
                                                            add_selectfile(e, archivo.id)}    
                                                    />
                                                    <Button variant="outlined" sx={{height:"30px", mr:1.5}}>
                                                        {archivo.nombre_archivo}
                                                    </Button>
                                                </Box>
                                            ))}
                                            </>
                                            :
                                            "MODULO SIN ARCHIVOS"
                                        }
                                    </Box>
                                }
                                </>
                                }
                                <Button variant="contained" color="success" sx={{mb:5}} 
                                onClick={typeModal === "Crear" ? saveNewUser : saveChangesUpdate}
                                disabled={new_User.email.length <= 0}>
                                    {typeModal === "Crear" ? "Crear " : "Actualizar "}Usuario</Button>
                            </Box>
                        </Modal>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {allUsers
                    .filter(usuario => user_datos.roluser_id === 1 || usuario.usuario_rol.id !== 1)
                    .map((usuario, index) => (
                        <TableRow key={index} sx={{":hover":{backgroundColor:"#e5e7e9"}}}>
                            <TableCell sx={styleRowBody}>{usuario.id}</TableCell>
                            <TableCell sx={styleRowBody}>
                                {usuario.nombre +" "+ usuario.apellido_p +" "+(usuario.apellido_m?usuario.apellido_m:"")}
                            </TableCell>
                            <TableCell sx={styleRowBody}>{usuario.email}</TableCell>
                            <TableCell sx={styleRowBody}>{changeLevelforIcon(usuario.usuario_rol.id)}</TableCell>
                            
                            <TableCell sx={styleRowBody}>
                                <Box sx={{display:"flex", alignItems:"center", gap:1, 
                                    justifyContent:"center"}}>

                                    {/*Editar Datos del Usuario*/}
                                    {permisos.includes("actualizar") &&
                                    <Tooltip title={"Editar"} arrow slotProps={styleToolTip}>
                                        <IconButton size="small" sx={{border:"1px solid", color:"#f1c40f"}}
                                        onClick={() => getInfoUserbyId(usuario.id)}>
                                            <Edit fontSize="small"/>
                                        </IconButton>
                                    </Tooltip>
                                    }
                                    
                                    {/*Eliminar Usuario*/}
                                    {permisos.includes("eliminar") &&
                                        <Tooltip title={"Eliminar"} arrow slotProps={styleToolTip}>
                                            <IconButton color="error" size="small" sx={{border:"1px solid"}}
                                            onClick={() => deleteUser(usuario.id)}>
                                                <Delete fontSize="small"/>
                                            </IconButton>
                                        </Tooltip>
                                    }
                                </Box>
                            </TableCell>
                            <TableCell sx={{...styleRowBody, width:0}} />
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            </TableContainer>

            {isCharging && <Loader />}
        </div>
    )
}

export default TableUsuarios;